<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Отправляем пуши

  .container.mt-5
    .row
      .col-sm-5
        //v-for=" card in push "
        .new-push-box
          h4 Кому
          .inputModule
            input-module(
              type="cards-push-recipients",
              v-model="newPush.recipients"
            )
          h4 Текст
          .inputModule
            input-module(
              type="textarea",
              title="Текст уведомления",
              v-model="newPush.message",
              emojis="true",
              :placements="placements",
              @change="updateTextExample"
            )
          h4 Время
          .inputModule
            input-module(
              type="cards-push-time-type",
              v-model="newPush.sendNow"
            )
            input-module(
              type="datetime",
              v-model="newPush.push_datetime",
              :disabled="newPush.sendNow.toString()"
            )
          .row.justify-content-end
            .col.text-right
              button.styled.sendPush(@click="addNewPush") {{ newPush.sendNow ? 'Отправить' : 'Запланировать' }} пуши
      .col-sm-3
        transition(name="scale", appear)
          img#iphone.iphone.scale(src="/assets/actid/iphone_frame.png")
        transition(name="iphone-shadow", appear)
          #iphone-box.col-auto.mx-auto.my-5.iphone-box.iphone-shadow
            .iphoneTime {{ newPush.sendNow ? moment().format('HH:mm') : moment(newPush.push_datetime, 'YYYY-MM-DD HH:mm').format('HH:mm') }}
            .iphoneDate {{ newPush.sendNow ? moment().format('dddd, DD MMMM') : moment(newPush.push_datetime, 'YYYY-MM-DD HH:mm').format('dddd, DD MMMM') }}
            transition(name="push")
              .iphone-push.my-4.push(
                v-show="pushShow & (newPush.textExample.length > 0)"
              )
                .iphone-push-header.d-flex.align-items-center
                  i.iphone-push-header-icon
                  span.iphone-push-header-title {{ shopName }}
                  span.iphone-push-header-time Сейчас
                .iphone-push-body-text {{ newPush.textExample }}
      .col-sm-4
        h4 Немного о пушах
        ul
          li Пуши - это отличный инструмент для информатирования гостей.
          li Отправка одного и более пушей стоит
            b 0 руб.
          li 
            b Не все пуши дойдут до гостей.
            | В среднем 90% гостей получат пуш.
          li Не стоит слишком часто отправлять пуши.
            b Мы рекомендуем не более 2 раз в сутки.
            | Это связано с тем, что устройство гостя может посчитать их спамом и выключит пуши у карты.

        h5 Почему пуш может не дойти?
        ul 
          li Отключены пуши приложения Wallet (iOS), Wallet Passes (Android)
          li Отключены пуши у карты
          li У карты отключено отображение на экране блокировки
          li Пользователь сам отключил пуши
          li Режим экономии энергии или трафика
          li Отсутствие подключения к интернету

  .container(style="margin-top: 100px")
    .row
      .col-12.header-push
        | {{ declOfNum(futurePushes.length, ['Запланирован', 'Запланировано', 'Запланировано']) }}
        span.header-push-count.font-weight-bold {{ futurePushes.length }} {{ declOfNum(futurePushes.length, ['пуш', 'пуша', 'пушей']) }}
    .row.pushes
      .col-sm-4(v-for="push of futurePushes")
        .push
          .copy(@click="copyPush(push)")
            i.far.fa-copy
          .inputModule
            input-module(
              type="datetime",
              title="Запланировано",
              v-model="push.push_datetime"
            )
          .inputModule
            input-module(
              type="textarea",
              title="Текст уведомления",
              v-model="push.message",
              emojis="true",
              :placements="placements"
            )
          .buttons
            button.styled.red(
              @click="removePush(push)",
              :disabled="push.loading"
            ) Удалить
            button.styled.green(
              @click="savePush(push)",
              :disabled="push.loading",
              style="margin-left: auto; margin-left: auto; display: block; float: right"
            ) Сохранить
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";
const uuidv1 = require("uuid/v1");

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      pushShow: false,
      moment: moment,

      shopName: "",

      newPush: {
        sendNow: true,
        message: "",
        textExample: "",
        recipients: "all",
        id: "",
        push_datetime: moment().add(1, "hour").format("YYYY-MM-DD HH:mm"),
      },

      placements: [
        { value: "GUESTNAME", name: "Имя гостя" },
        { value: "GUESTLASTNAME", name: "Фамилия гостя" },
        { value: "GUESTFULLNAME", name: "Полное имя гостя" },
      ],

      futurePushes: [],
    };
  },

  computed: {},

  mounted() {
    this.iphonePosition();
    window.addEventListener("resize", this.iphonePosition);
    this.shopName = this.$store.state.userData.shop.name;
    setTimeout(() => (this.pushShow = true), 3000);
    this.loadPushes();
  },

  methods: {
    async loadPushes() {
      let futurePushes = (
        await apiDriver.services.api.get("cards", "push/futurePushes")
      ).data.pushes;
      for (let p of futurePushes) p.loading = false;
      for (let p of futurePushes) p.push_datetime = moment(p.push_datetime).format("YYYY-MM-DD HH:mm");
      this.futurePushes = futurePushes;
      console.log("futurePushes", futurePushes);
    },
    async addNewPush() {
      if (this.newPush.message.length > 0) {
        this.newPush.id = uuidv1();
        let cloneNewPush = {};
        for (let key in this.newPush) cloneNewPush[key] = this.newPush[key];
        this.$toast.info(`Отправляю запрос на создание пушей...`);
        let data = {};
        data.datetime = cloneNewPush.sendNow
          ? "now"
          : moment(cloneNewPush.push_datetime, "YYYY-MM-DD HH:mm").format(
              "YYYY-MM-DD HH:mm:00"
            ); //2019-08-01 23:22:11
        data.text = cloneNewPush.message;
        data.cards = this.newPush.recipients;
        this.pushDate = "";
        this.pushTime = "";
        this.newPush.message = "";
        this.newPush.recipients = "all";
        this.newPush.sendNow = true;
        await apiDriver.services.api.post("cards", "push/makeJob", data);
        if (cloneNewPush.sendNow) {
          this.$toast.success(`Пуши успешно отправлены!`);
        } else {
          this.$toast.success(`Пуши успешно запланированы!`);
        }
        if (!cloneNewPush.sendNow) this.loadPushes();
      }
    },
    async removePush(push) {
      push.loading = true;
      this.$toast.info("Удаляю пуш...");
      let _push = JSON.parse(JSON.stringify(push));
      delete _push.loading;
      let removed = (
        await apiDriver.services.api.post("cards", "push/removePush", _push)
      ).data.done;
      if (removed) {
        this.$toast.success("Пуш успешно удалён!");
        this.futurePushes = this.futurePushes.filter((x) => x.id != _push.id);
      } else {
        this.$toast.error("Произошла ошибка во время удаления пуша...");
      }
      push.loading = false;
    },
    async savePush(push) {
      push.loading = true;
      this.$toast.info("Сохраняю пуш...");
      let _push = JSON.parse(JSON.stringify(push));
      delete _push.loading;
      let removed = (
        await apiDriver.services.api.post("cards", "push/updatePush", _push)
      ).data.done;
      if (removed) {
        this.$toast.success("Пуш успешно сохранён!");
      } else {
        this.$toast.error("Произошла ошибка во время сохранения пуша...");
      }
      push.loading = false;
    },
    copyPush(push) {
      this.newPush = push;
      this.newPush.textExample = "";
      this.newPush.this.newPush.recipients = "all";
      this.newPush.id = "";
      this.newPush.sendNow = false;
      this.updateTextExample();
      window.scrollTo({ top: 40, behavior: "smooth" });
    },

    iphonePosition() {
      let iphone = document.getElementById("iphone");
      let iphoneBox = document.getElementById("iphone-box");

      iphone.style.left = iphoneBox.offsetLeft - 8 + "px";
      iphone.style.top = iphoneBox.offsetTop - 5 + "px";
    },
    updateTextExample() {
      let x = this.newPush.message
        .replace(/GUESTNAME/g, "Анастасия")
        .replace(/GUESTLASTNAME/g, "Иванова")
        .replace(/GUESTFULLNAME/g, "Анастасия Иванова");
      this.newPush.textExample = x;
    },
    declOfNum(number, titles) {
      let cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
  },
};
</script>
<style scoped lang="stylus">
h4 {
  margin-top: 0;
}

h5 {
  font-size: 14pt;
  margin-bottom: 10px;
}

.inputModule {
  margin-bottom: 10px;
}

div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.header-push-count {
  color: rebeccapurple;
  margin-left: 10px;
}

.new-push-box {
  position: relative;
  font-size: 1rem;
  padding: 15px;
  transition: all 0.5s ease;
  background: white;
  color: black;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.iphone {
  width: 268px !important;
  height: 540px !important;
  position: absolute;
  left: 0;
  top: -5px;
  z-index: 2;

  &.scale {
    transform: scale(1);
  }

  &.scale-enter-active, &.scale-leave-active {
    transition: transform 1s ease;
    transition-delay: 1s;
  }

  &.scale-enter, &.scale-leave-to {
    transform: scale(0.96);
  }

  &.iphone-shadow-enter, &.iphone-shadow-leave-to {
    box-shadow: none;
    transform: scale(0.96);
  }
}

.iphone-box {
  width: 250px;
  height: 525px;
  padding: 7px;
  border-radius: 37px;
  background-position: center;
  background-size: cover;
  background-clip: content-box;
  background: linear-gradient(45deg, #673AB7, #2196F3);

  &.scale {
    transform: scale(1);
  }

  &.scale-enter-active, &.scale-leave-active {
    transition: transform 1s ease;
    transition-delay: 1s;
  }

  &.scale-enter, &.scale-leave-to {
    transform: scale(0.96);
  }

  &.iphone-shadow-enter, &.iphone-shadow-leave-to {
    box-shadow: none;
    transform: scale(0.96);
  }

  &.iphone-shadow {
    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2);
    transform: scale(1);
  }

  &.iphone-shadow-enter-active, &.iphone-shadow-leave-active {
    transition: box-shadow 1s ease, transform 1s ease;
    transition-delay: 1s;
  }

  &.iphone-shadow-enter, &.iphone-shadow-leave-to {
    box-shadow: none;
    transform: scale(0.96);
  }

  .iphoneTime {
    text-align: center;
    color: white;
    margin-top: 40px;
    font-size: 35pt;
  }

  .iphoneDate {
    text-align: center;
    color: white;
    margin-top: 0px;
    position: relative;
    top: -5px;
    text-transform: capitalize;
  }

  .push {
    transform: translateY(0px) scale(1);
    min-height: 45px;
    opacity: 1;

    &.iphone-push-eva {
      position: relative;
      background: rgba(256, 256, 256, 0.8);
      border-radius: 10px;
      margin: 100px 11px;
      margin-bottom: 5px;
      padding: 5px;
    }

    &.iphone-push {
      position: relative;
      background: rgba(256, 256, 256, 0.8);
      border-radius: 10px;
      margin: 0px 11px;
      padding: 5px;
    }

    &.push-enter, &.push-leave-to {
      transform: translateY(25px) scale(0.8);
      opacity: 0;
    }

    &.push-enter-active, &.push-leave-active {
      transition: all 0.5s ease;
    }

    .iphone-push-header-icon {
      background: white;
      border-radius: 4px;
      color: white;
      font-size: 10px;
      padding: 0;
      height: 12px;
      width: 12px;
    }

    .iphone-push-header-title {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 10px;
      font-weight: 500;
      color: #7a7a7a;
      margin-left: 4px;
    }

    .iphone-push-header-time {
      font-size: 10px;
      font-weight: 500;
      color: #7a7a7a;
      margin-left: auto;
    }

    .iphone-push-body-title {
      font-size: 10px;
      font-weight: 600;
      margin-top: 3px;
    }

    .iphone-push-body-text {
      font-size: 10px;
      margin-top: 5px;
      white-space: pre-line;
    }
  }
}

.pushes {
  margin-top: 20px;

  .push {
    background: white;
    padding: 15px 10px;
    padding-top: 25px;
    position: relative;
    border-radius: 4px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    transition: 0.3s all;

    &:hover {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }

    .buttons {
      margin-top: 15px;
      padding: 0 10px;
    }

    .copy {
      position: absolute;
      right: 18px;
      top: 10px;
      z-index: 1;
      cursor: pointer;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .new-push-box {
    background: #1a1a1a;
    color: #fff;
  }

  .iphone {
    filter: invert(1);
  }

  .iphone-box {
    background: linear-gradient(45deg, #1c1032, #818f9b);
  }

  .header-push {
    color: white;
  }

  .header-push-count {
    color: #a557f3;
  }

  .iphone-box .push.iphone-push {
    background: rgba(20, 20, 20, 0.8);
  }

  .iphone-box .push .iphone-push-header-icon {
    background: #484848;
  }
}
</style>
